module.exports = __webpack_public_path__ + "static/media/p2008gisht.58d5db2c.jpg";